import React from "react"
import Headroom from "react-headroom"
import AnchorLink from "react-anchor-link-smooth-scroll"
import styles from "./Header.module.css"
import logo from "../../images/logo.png"
import { Spin as Hamburger } from "hamburger-react"

const Header = props => {
  return (
    <Headroom
      wrapperStyle={{ position: "fixed", zIndex: "100" }}
      style={{
        background: "#f7f7f7",
        boxShadow: "1px 1px 1px rgba(0,0,0,0.25)",
        margin: "0",
        padding: "1rem",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        height: "40px",
        position: "fixed",
      }}
      className={styles.headerWrapper}
    >
      <AnchorLink href="#home-page" offset="0">
        <img className={styles.logo} src={logo} alt="logo" />
      </AnchorLink>
      <div className={styles.navigation}>
        <AnchorLink href="#home-page" offset="0" className="linkTo">
          Home
        </AnchorLink>
        <AnchorLink href="#about-page" offset="0" className="linkTo">
          About
        </AnchorLink>
        <AnchorLink href="#gallery-page" offset="0" className="linkTo">
          Gallery
        </AnchorLink>
        <AnchorLink href="#services-page" offset="0" className="linkTo">
          Services
        </AnchorLink>
        <AnchorLink href="#testimonials-page" offset="0" className="linkTo">
          Testimonials
        </AnchorLink>
        <AnchorLink href="#contact-page" offset="0" className="linkTo">
          Contact
        </AnchorLink>
      </div>
      <Hamburger
        className={styles.hamburgerReact}
        toggle={props.toggle}
        toggled={props.isSidebarOpen}
        color="#000"
        label="Show sidebar"
        rounded
      />
    </Headroom>
  )
}

export default Header
